import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showClearIndicator"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { components } from '@atlaskit/select';
var calendarButtonInclusionStyles = css({
  marginInlineStart: "var(--ds-space-400, 32px)"
});
var calendarButtonOnlyInclusionStyles = css({
  marginInlineStart: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var IndicatorsContainer = function IndicatorsContainer(_ref) {
  var showClearIndicator = _ref.showClearIndicator,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", {
    css: showClearIndicator ? calendarButtonInclusionStyles : calendarButtonOnlyInclusionStyles
  }, jsx(components.IndicatorsContainer, rest));
};